module.exports = __webpack_public_path__ + "static/media/FPS.abf2198c.jpg";